import {
  TRANSFERDETAIL_LOADING,
  GET_TRANSFERDETAIL,
  GET_TRANSFERDETAIL_SUCCESS,
  GET_TRANSFERDETAIL_FAIL,
  ADD_TRANSFERDETAIL_SUCCESS,
  ADD_TRANSFERDETAIL_FAIL,
  DELETE_TRANSFERDETAIL_SUCCESS,
  DELETE_TRANSFERDETAIL_FAIL,
  UPDATE_TRANSFERDETAIL_SUCCESS,
  UPDATE_TRANSFERDETAIL_FAIL,
  TRANSFERDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  transferDetails: [],
  error: {},
};

const TransferDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TRANSFERDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_TRANSFERDETAIL:
          return {
            ...state,
            transferDetails: action.payload.data,
            isTransferDetailCreated: false,
            isTransferDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_TRANSFERDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_TRANSFERDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isTransferDetailCreated: false,
            isTransferDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_TRANSFERDETAIL: {
      return {
        ...state,
        isTransferDetailCreated: false,
        loading: true,
      };
    }

    case TRANSFERDETAIL_LOADING: {
      return {
        ...state,
        isTransferDetailCreated: false,
        loading: true,
      };
    }

    case ADD_TRANSFERDETAIL_SUCCESS:
      return {
        ...state,
        isTransferDetailCreated: true,
        loading: false,
        transferDetails: [action.payload.data, ...state.transferDetails],
      };

    case ADD_TRANSFERDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_TRANSFERDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isTransferDetailCreated: true,
        transferDetails: state.transferDetails.filter(
          transferDetail => transferDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_TRANSFERDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TRANSFERDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isTransferDetailCreated: true,
        transferDetails: state.transferDetails.map(transferDetail =>
          transferDetail.id.toString() === action.payload.data.id.toString() ? { ...transferDetail, ...action.payload.data } : transferDetail
        ),
      };

    case UPDATE_TRANSFERDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case TRANSFERDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default TransferDetail;